<template>
  <div class="champion" @click="$router.push({ name: 'leaderboard', params: { initialSlide: currentOpponentIndex, postResultsMode: true } })">
    <div class="main">
      <div class="message">
        <BaseText3 text="you are the ultimate staredown champion"/>
        <img class="champion-c" src="@/assets/img/champion-c.png" alt="champion-c">
      </div>
      <div class="champion-ranking">
        <BaseText2 text="ranked ultimate staredown"/>
        <div class="container">
          <div class="letter">C</div>
          <div class="info">Champion</div>
        </div>
      </div>
    </div>
    <BaseText2 class="subcopy" text="Tap to continue"/>
  </div>
</template>

<script>
import BaseText2 from '@/components/BaseText2/BaseText2'
import BaseText3 from '@/components/BaseText3/BaseText3'
import { opponentIds } from '@/data/opponents'
import { mapState } from 'vuex'
export default {
  name: 'champion',
  components: {
    BaseText2,
    BaseText3
  },
  computed: {
    ...mapState('gameplay', [
      'selectedOpponentId'
    ]),
    currentOpponentIndex () {
      return opponentIds.indexOf(this.selectedOpponentId)
    }
  }
}
</script>

<style lang="scss" scoped>
.champion {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: var(--spacing-1);
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media #{$media-3} {
    max-width: 20rem;
  }
}
.message {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 24rem;
  .base-text-3 {
    font-size: 3.5rem;
    line-height: 3rem;
    text-align: right;
  }
  .champion-c {
    position: absolute;
    z-index: -1;
  }
}
.champion-ranking {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  .base-text-2 {
    font-size: 0.625rem;
    --letter-spacing: 0.05em;
    letter-spacing: var(--letter-spacing);
    opacity: 0.5;
    margin: 0 0 0.5rem 0;
  }
  .container {
    display: flex;
    width: 100%;
    height: 3.5rem;
    .letter {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      width: 4.5rem;
      height: 100%;
      background: var(--color-gold-1);
      color: var(--color-black-1);
      flex-shrink: 0;
    }
    .info {
      font-family: 'Klavika Medium';
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: var(--spacing-3) var(--spacing-4);
      background: var(--color-gray-2);
      font-size: 1rem;
      text-transform: uppercase;
      width: 100%;
      overflow: hidden;
    }
  }
}
.subcopy {
  font-size: 0.625rem;
  --letter-spacing: 0.05em;
  letter-spacing: var(--letter-spacing);
}
</style>
